import { useState } from "react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { IUserRecord } from "@/ts/common-types";
import { convertIsoDate } from "@/ts/utils";

dayjs.extend(utc);
dayjs.extend(timezone);

type RecordType = IUserRecord;

export const ExpirationDateCell = ({
    record,
    currentTimeZone,
}: {
    record: RecordType;
    currentTimeZone: string;
}) => {
    const [showFullDate, setShowFullDate] = useState(false);

    const expiryDate = record.expiry_date
        ? dayjs(record.expiry_date).tz(currentTimeZone)
        : null;
    const today = dayjs().tz(currentTimeZone);
    const diffDays = expiryDate ? expiryDate.diff(today, "day") : null;

    const getRelativeTime = () => {
        if (!expiryDate) return "Never";
        if (diffDays === 0) return "Today";
        if (diffDays === 1) return "Tomorrow";
        if (diffDays === -1) return "Yesterday";
        if (diffDays < -1) return `${Math.abs(diffDays)} days ago`;
        return `in ${diffDays} days`;
    };

    const isExpiringSoon = diffDays !== null && diffDays <= 1;

    return (
        <div
            onClick={() => setShowFullDate(!showFullDate)}
            style={{ cursor: "pointer" }}
        >
            {showFullDate ? (
                <div>
                    <div>
                        {record.expiry_date
                            ? `${convertIsoDate(
                                  record.expiry_date,
                                  currentTimeZone
                              )}`
                            : "Never"}
                    </div>
                    <div className="small text-muted">
                        {record.expiry_date
                            ? `${convertIsoDate(record.expiry_date)} - UTC`
                            : ""}
                    </div>
                </div>
            ) : (
                <div style={{ color: isExpiringSoon ? "#ff4d4f" : "inherit" }}>
                    {getRelativeTime()}
                </div>
            )}
        </div>
    );
};
